import PropTypes from 'prop-types';
import React from 'react';
import { getComponentClasses } from '@99designs/common/utils/app';

const Section = ({ id, children, variations }) => {
    const classes = getComponentClasses('section', variations);

    return (
        <section id={id} className={classes}>
            {children}
        </section>
    );
};

Section.propTypes = {
    id: PropTypes.string,
    variations: PropTypes.array,
};

Section.defaultProps = {
    id: null,
    variations: [],
};

export default Section;
